import { render, staticRenderFns } from "./Projects.vue?vue&type=template&id=6c3afadf&scoped=true&"
import script from "./Projects.vue?vue&type=script&lang=js&"
export * from "./Projects.vue?vue&type=script&lang=js&"
import style0 from "./Projects.vue?vue&type=style&index=0&id=6c3afadf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3afadf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/ddv-home/ddv-home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c3afadf')) {
      api.createRecord('6c3afadf', component.options)
    } else {
      api.reload('6c3afadf', component.options)
    }
    module.hot.accept("./Projects.vue?vue&type=template&id=6c3afadf&scoped=true&", function () {
      api.rerender('6c3afadf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ddv-home/Projects.vue"
export default component.exports